import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  avatarCancel: {
    width: '52px',
    height: '52px',
    border: '2px solid #F79999',
  },
}));
